<template>
    <Overlay v-model="visibleModel">
      <div @click.stop class="container">
        <div class="go-premium"></div>
        <div class="unlock-title"></div>
        <div class="sku-wrap">
          <div @click="activeType = 'single'" :class="['sku-item', activeType === 'single' ? 'active' : '']">
            <p class="sku-title">Single Chapter</p>
            <div class="sku-price">
              <i class="icon-diamond"></i>
              {{info.single}}
            </div>
          </div>
          <div @click="activeType = 'all'" :class="['sku-item', activeType === 'all' ? 'active' : '']">
            <p class="sku-title">All Chapters</p>
            <div class="sku-price">
              <i class="icon-diamond"></i>
              {{info.total}}
            </div>
          </div>
        </div>
        <div class="wallet">
          <span>My Balance：</span>
          <div class="right">
            <i class="icon-diamond"></i>
            <span>{{ userInfo.coin }}</span>
          </div>
        </div>
        <div @click="unlock" class="unlock-button">
          Unlock {{activeType === 'single' ? info.title : 'All'}}
        </div>
      </div>
    </Overlay>
</template>

<script>
import { unlockChapter, unlockNovels } from '@/api';
import Overlay from '@/components/Overlay';
import { debounce } from '@/utils';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: { Overlay },
  props: {
    visible: Boolean,
    info: Object,
  },
  data() {
    return {
      activeType: 'single',
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
    ]),
    visibleModel: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  methods: {
    ...mapActions([
      'subtractCoin',
    ]),
    async unlock() {
      const {
        novelId, chapterId, single = 0, total = 0,
      } = this.info || {};
      let usedCoin;
      let api;
      if (this.activeType === 'single') {
        api = unlockChapter;
        usedCoin = single;
      } else {
        api = unlockNovels;
        usedCoin = total;
      }
      if (this.userInfo.coin < usedCoin) {
        this.goTopUp();
        return;
      }
      const loading = this.$loading();
      const res = await api(novelId, chapterId);
      loading.close();
      if (res.code === 4002) {
        this.goTopUp();
        return;
      }
      if (res.code !== 0) {
        this.$toast.error(res.message || 'Network Fail');
        return;
      }
      this.subtractCoin(usedCoin);
      this.$emit('success', chapterId);
      this.visibleModel = false;
    },
    goTopUp: debounce(function goTopUp() {
      this.$toast.error('Insufficient Balance');
      const t = setTimeout(() => {
        clearTimeout(t);
        this.$router.push('/topup');
      }, 300);
    }, 500, true),
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 480px;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url('~@/assets/images/bg/unlock-bg.png');
  background-position: 12px 0px;
  padding-top: 170px;
  .go-premium {
    width: 285px;
    height: 50px;
    margin: 0 auto;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('~@/assets/images/bg/unlock-premium.png');
    margin-bottom: 24px;
  }
  .unlock-title {
    width: 296px;
    height: 23px;
    margin: 0 auto;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('~@/assets/images/bg/unlock-title.png');
    margin-bottom: 16px;
  }
  .sku-wrap {
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;
    .sku-item {
      width: 132px;
      height: 100px;
      border: 1px solid rgb(60, 92, 75);
      border-radius: 12px;
      color: #fff;
      overflow: hidden;
      &:first-of-type{
        margin-right: 16px;
      }
      &.active {
        .sku-price {
          background-color: rgba(23, 175, 132, .3);
        }

      }
      .sku-title {
        background-color: rgba(23, 175, 132, 1);
        line-height: 43px;
        text-align: center;
        // border-radius: 12px 12px 0 0;

        font-size: 16px;
        font-weight: 600;
      }
      .sku-price {
        height: 57px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        font-weight: 700;
        .icon-diamond {
          margin-right: 5px;
          .iconMixin({
            background-image: url('~@/assets/images/icon/diamond.png');
          });
        }
      }
    }
  }
  .wallet {
    display: flex;
    padding: 0 40px;
    font-size: 16px;
    line-height: 20px;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    margin-bottom: 16px;
    .right {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 700;
      .icon-diamond {
        width: 16px;
        height: 16px;
        margin-right: 5px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url('~@/assets/images/icon/diamond.png');
      }
    }
  }
  .unlock-button {
    width: 248px;
    height: 44px;
    margin: 0 auto;
    border-radius: 22px;
    line-height: 44px;
    text-align: center;
    background-image: linear-gradient(180deg, #F9E75E 0%, #F8A81F 100%);
    font-size: 20px;
    font-weight: 700;
    color:rgba(24, 77, 78, 1);

  }
}

</style>
